import { Component, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/app.service';
import { OrgaosService } from 'src/app/services/orgaos.service';
import { DadosCargasService } from 'src/app/services/dados-cargas.service';

@Component({
    selector: 'app-modal-atualiza-orgaos',
    templateUrl: './modal-atualiza-orgaos.component.html',
    providers: [OrgaosService]
})

export class ModalAtualizaOrgaosComponent implements OnInit {

    modalRef: NgbModalRef;
    public orgao: any;
    public listaEstados = [];

    constructor(
        private appService: AppService,
        private orgaosService: OrgaosService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private dadosCargasService: DadosCargasService
    ) { }

    ngOnInit(): void {
        this.orgao = this.modalRef.componentInstance.orgao;
        this.listaEstados = this.dadosCargasService.mockEstados();
    }

    atualizar() {
        this.update(this.orgao);
    }

    update(orgao) {
        this.spinner.show();
        this.toastrService.clear();

        this.orgaosService.update(orgao)
            .subscribe(res => {
                this.toastrService.success("Órgão atualizado!.", "Sucesso");
                this.modalRef.close({ result: true, page: this.modalRef.componentInstance.page, acao: 'atualizado' });
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível atualizar o Órgão!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });
    }

    close() {
        this.modalRef.close();
    }

    dismiss() {
        this.modalRef.dismiss();
    }
}

